export default {
  props: {
    type: String,
    id: String,
    visible: Boolean,
    dic: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.handleShow()
      }
    }
  },
  data() {
    return {
      // dialogLoading: false, // 弹窗数据加载遮罩
    }
  },
  mounted() {
    this.handleShow()
  },
  methods: {
    handleShow() { // 初始化弹窗
      // 新增，更改领取人手机号、……
      this.handleOtherInitData()
      // 修改
      this.handleEditInitData()
    },
    // 修改之外的其他操作（新增，更新领取人手机号 ……）
    handleOtherInitData() {
      const resetFormData = ['add', 'updateUser', 'storesReturnedRecord']
      if (resetFormData.includes(this.type)) { // 新增弹窗， 清空输入框内容
        if (!this.$refs.dialogForm) {
          return
        }
        this.$refs.dialogForm.resetFields()
      }
    },
    handleEditInitData() {
      if (this.type === 'edit') {
        if (this.findByIdUrl) { // 需要访问后端得到初始化数据
          this.$http.post(this.findByIdUrl, this.id)
            .then(res => {
              if (res.data.code !== 1) {
                this.$notify.error({
                  title: '错误',
                  message: '获取用户数据错误'
                })
                return
              }
              // 给表单绑定初始值
              const keys = Object.keys(this.dialogFormData)
              keys.forEach(item => {
                this.dialogFormData[item] = res.data.data[item]
              })
              this.dialogFormData.id = this.id // 额外添加该行数据的id
            })
        } else if (this.initDialogFormdata) {
          this.initDialogFormdata() // 初始化弹窗 form 数据
        }
      }
    }
  }
}
